import styled from 'styled-components';

export const StyledSectionLineWrapper = styled.div`
  height: 3rem;
  margin-bottom: 1.666rem;
  position: relative;
`;
